import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { PaginatedResponse, ReviewQueueItem } from '../types';
import Spinner from '../components/Spinner';
import EmptyState from '../components/EmptyState';
import Badge from '../components/Badge';

const priorityVariant: Record<string, 'danger' | 'warning' | 'default'> = {
  high: 'danger',
  normal: 'warning',
  low: 'default',
};

const statusVariant: Record<string, 'info' | 'warning' | 'success'> = {
  pending: 'info',
  in_progress: 'warning',
  resolved: 'success',
};

export default function ReviewQueue() {
  const [items, setItems] = useState<ReviewQueueItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.get<PaginatedResponse<ReviewQueueItem>>('/review-queue')
      .then((res) => setItems(res.data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Spinner text="Loading review queue..." />;
  if (error) return <p className="error">{error}</p>;

  return (
    <div>
      <h1>Review Queue</h1>
      <p className="text-muted">{items.length} pending item{items.length !== 1 ? 's' : ''}</p>
      {items.length === 0 ? (
        <EmptyState
          title="All clear"
          description="No items pending review. The pipeline will create new items when it encounters ambiguous situations."
        />
      ) : (
        <table className="data-table">
          <thead>
            <tr>
              <th>Priority</th>
              <th>Type</th>
              <th>Question</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.id}>
                <td><Badge label={item.priority} variant={priorityVariant[item.priority]} /></td>
                <td><Badge label={item.entity_type} /></td>
                <td>{item.question}</td>
                <td><Badge label={item.status} variant={statusVariant[item.status]} /></td>
                <td><Link to={`/review/${item.id}`}>Review</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
